import { Box, Button, Typography } from "@material-ui/core";
import { useState } from "react";
// import { ActionHeader } from '.';
import en from "../../lang/en-us";
import { UploadFile } from "../../lib/UploadFile.tsx";
import Image from "../Image";
const { dashboard } = en;

export default function UploadDocumentScreen({
  backLink = "",
  heading = "",
  subheading = "",
  info1 = "",
  info2 = "",
  showMobile = false,
  linkText = "",
  nextLink = "",
  id = "document",
  emailInfo = "",
  mobile = "",
  mobileInfo = "",
  onImageSelected = (value: any, format: any) => {},
  handleSubmit = () => {},
  isDisabled = true,
  hrefLink = "#",
  email = "",
}) {
  return (
    <>
      {/* <ActionHeader header={heading} /> */}
      {/* <div style={{ boxShadow: "lightgray 0px 0px 2px 0px" }}></div> */}
      <Box
        className="curved-bg-content"
        sx={{ width: ["100%", "80%"], mx: "auto" }}
      >
        {/* <img
          className="upload-character"
          src="/images/upload-character.png"
          alt="icon"
        /> */}
        <Box
          className="upload-info-navbar"
          sx={{
            bgcolor: "#e1e1e1",
            display: "flex",
            padding: "16px",
            borderRadius: "8px",
            justifyContent: "space-between",
            alignItems: "center",
            mx: [0, "20px"],
          }}
        >
          {/* <div style={{ display: "flex", alignItems: "center" }}> */}
          <div
            style={{
              display: "flex",
              gap: "1rem",
            }}
          >
            <p
              style={{
                fontFamily: "OpenSans-Bold",
                marginBottom: "0",
              }}
            >
              {showMobile ? "Mobile" : "Email"}
            </p>
            <p style={{ marginBottom: "0" }}>{email ? email : mobile}</p>
          </div>

          {/* <InfoIcon /> */}
          <Box>
            <Image src={"/images/i-icon-grey.svg"} alt="icon" />
            <span
              style={{ marginBottom: "0", color: "grey", marginLeft: "10px" }}
            >
              {mobileInfo ? mobileInfo : emailInfo}
            </span>
          </Box>
          {/* </div> */}
        </Box>
        <hr />
        <div className="curved-bg-content-inner">
          <div className="curved-bg-content-inner-top">
            {/* <h3 className="subheading">{subheading}</h3> */}

            {/* <Box sx={{" p"}}> */}

            <UploadFile onImageSelected={onImageSelected} id={id} />
          </div>

          <div className="curved-bg-content-inner-bottom">
            <Button
              // href={`/portal/${nextLink}`}
              onClick={handleSubmit}
              className="customBtn"
              disabled={!isDisabled}
            >
              {dashboard.changeEmail.UploadDocument.buttonText}
            </Button>
          </div>
        </div>
      </Box>
    </>
  );
}
